import FormattedDateTime from 'I18n/components/FormattedDateTime';
//@ts-expect-error FormattedDuration does not have a TS implementation.
import FormattedDuration from 'I18n/components/FormattedDuration';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { dueDateBreached, getIsDueInLessThanEightHours, getIsDueTomorrow, isDueToday } from 'conversations-internal-schema/sla/operators/dueDateComparators';
import { useCurrentTime } from '../../../_internal/hooks/useCurrentTime';
import { jsx as _jsx } from "react/jsx-runtime";
const SLADetailsTime = ({
  dueDate,
  isPausedSLA
}) => {
  const {
    currentTime
  } = useCurrentTime(100);
  if (dueDateBreached(currentTime, dueDate)) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.pastDueBy",
      options: {
        time: /*#__PURE__*/_jsx(FormattedDuration, {
          from: dueDate,
          format: "medium",
          combined: true
        })
      }
    });
  }
  const dueDateObject = new Date(dueDate);
  // Paused SLAs should always show the time relative to now
  if (isPausedSLA) {
    return /*#__PURE__*/_jsx(FormattedDuration, {
      to: dueDate,
      format: "medium",
      combined: true
    });
  }
  if (getIsDueTomorrow(currentTime, dueDateObject)) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.tommorrowByTime",
      options: {
        time: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "LT",
          value: dueDate
        })
      }
    });
  }
  if (getIsDueInLessThanEightHours(dueDate, currentTime)) {
    return /*#__PURE__*/_jsx(FormattedDuration, {
      to: dueDate,
      format: "medium",
      combined: true
    });
  }
  if (isDueToday(currentTime, dueDateObject)) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.byTime",
      options: {
        timeOrDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "LT",
          value: dueDate
        })
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedDateTime, {
    format: "llll",
    value: dueDate
  });
};
SLADetailsTime.displayName = 'SLADetailsTime';
export default SLADetailsTime;